/* eslint-disable @wordpress/no-unused-vars-before-return */
import domReady from '@wordpress/dom-ready';
import {
	getScrollPercent,
	setDismissPopupDataOnLocalStorage,
	getDismissPopupDataOnLocalStorage,
	getCurrentPostOrPageId,
} from './utils';

domReady( () => {
	const dbPopupBlocks = document.querySelectorAll(
		'.wp-block-do-blocks-popup'
	);

	dbPopupBlocks?.forEach( ( block ) => {
		const closeBtn = block.querySelector(
			'.wp-block-do-blocks-popup-close-btn'
		);
		const dismissBtn = block.querySelector(
			'.wp-block-do-blocks-popup-dismiss-btn'
		);
		const popupBodyBlock = block.querySelector(
			'.wp-block-do-blocks-popup-body'
		);
		const getBlockAttributes = block.getAttribute(
			'data-db-popup-block-settings'
		);
		const attributes = JSON.parse( getBlockAttributes );
		const {
			popupId,
			openTrigger,
			openTriggerDelay,
			openTriggerAnchor,
			scrollDistance,
			excludePages,
			showCloseButton,
			closeOnClickOutside,
			escOnClose,
			closeOnReVisitors,
			displayInterval,
		} = attributes;
		const expireDate = closeOnReVisitors
			? getDismissPopupDataOnLocalStorage( 'db-close-popup', popupId )
			: null;

		if ( ! getCurrentPostOrPageId( excludePages ) ) {
			/**
			 * Handle page load event
			 */
			if ( openTrigger === 'load' && ! expireDate ) {
				setTimeout( () => {
					block.style.display = 'block';
					popupClosesFunc();
				}, openTriggerDelay * 1000 );
			}

			/**
			 * Handle click event
			 */
			if (
				openTrigger === 'click' &&
				openTriggerAnchor &&
				! expireDate
			) {
				const triggerButtons = document.querySelectorAll(
					`.${ openTriggerAnchor }`
				);
				if ( ! triggerButtons.length ) return;

				triggerButtons.forEach( ( button ) => {
					button.addEventListener( 'click', () => {
						block.style.display = 'block';
						popupClosesFunc();
					} );
				} );
			}

			/**
			 * Handle scroll event
			 */
			const scrollEventCallbackFunc = () => {
				if ( getScrollPercent() >= scrollDistance ) {
					block.style.display = 'block';
					popupClosesFunc();
				}
			};
			if ( openTrigger === 'scroll' && ! expireDate ) {
				window.addEventListener( 'scroll', scrollEventCallbackFunc );
			}

			/**
			 * Check if device is mobile
			 */
			const isMobileDevice = () => {
				return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
					navigator.userAgent
				);
			};

			/**
			 * Handle when user outside the viewport Aka (Exit-Intent)
			 */
			let lastY = 0;
			let timer;

			// Desktop exit intent handler
			const exitIntentDesktopHandler = ( e ) => {
				if ( ! e.toElement && ! e.relatedTarget ) {
					block.style.display = 'block';
					popupClosesFunc();
				}
			};

			// Mobile exit intent handlers
			const touchStartHandler = ( e ) => {
				lastY = e.touches[ 0 ].clientY;
				clearTimeout( timer );
			};

			const touchMoveHandler = ( e ) => {
				const currentY = e.touches[ 0 ].clientY;
				// If user is scrolling up near the top of the page
				if ( currentY > lastY && window.scrollY < 200 ) {
					// User might be trying to exit (pull-to-refresh or navigate away)
					timer = setTimeout( () => {
						block.style.display = 'block';
						popupClosesFunc();
					}, 100 );
				}
				lastY = currentY;
			};

			// Handle browser back button press
			const backButtonHandler = ( e ) => {
				// Show popup and prevent default behavior
				block.style.display = 'block';
				popupClosesFunc();
				// Push a new state to prevent actually going back
				history.pushState( null, document.title, window.location.href );
				e.preventDefault();
			};

			if ( openTrigger === 'exit-intent' && ! expireDate ) {
				if ( isMobileDevice() ) {
					// Mobile exit intent detection
					document.addEventListener(
						'touchstart',
						touchStartHandler,
						{
							passive: true,
						}
					);
					document.addEventListener( 'touchmove', touchMoveHandler, {
						passive: true,
					} );

					// Monitor browser back button
					history.pushState(
						null,
						document.title,
						window.location.href
					);
					window.addEventListener( 'popstate', backButtonHandler );

					// Also detect rapid upward scrolling as potential exit intent
					let scrollStart = 0;
					let scrollEnd = 0;
					let isScrolling;

					window.addEventListener(
						'scroll',
						() => {
							// Clear our timeout throughout the scroll
							window.clearTimeout( isScrolling );

							// Set starting scroll position
							if ( scrollStart === 0 ) {
								scrollStart = window.scrollY;
							}

							// Update scroll position
							scrollEnd = window.scrollY;

							// If we're scrolling up quickly and near the top, show popup
							if (
								scrollStart - scrollEnd > 100 &&
								scrollEnd < 300
							) {
								block.style.display = 'block';
								popupClosesFunc();
								scrollStart = 0;
								scrollEnd = 0;
							}

							// Set a timeout to run after scrolling ends
							isScrolling = setTimeout( () => {
								scrollStart = 0;
								scrollEnd = 0;
							}, 100 );
						},
						{ passive: true }
					);
				} else {
					// Desktop exit intent detection (original method)
					document.addEventListener(
						'mouseout',
						exitIntentDesktopHandler
					);
				}
			}

			const removeAllEventListener = () => {
				// Remove desktop listeners
				document.removeEventListener(
					'mouseout',
					exitIntentDesktopHandler
				);
				window.removeEventListener( 'scroll', scrollEventCallbackFunc );

				// Remove mobile listeners
				document.removeEventListener( 'touchstart', touchStartHandler );
				document.removeEventListener( 'touchmove', touchMoveHandler );
				window.removeEventListener( 'popstate', backButtonHandler );
			};

			/**
			 * Handle all close methods
			 */
			const popupClosesFunc = () => {
				/**
				 * Handle close button
				 */
				const clickCloseBtnCallbackFunc = () => {
					block.style.display = 'none';
					if ( closeOnReVisitors ) {
						setDismissPopupDataOnLocalStorage(
							'db-close-popup',
							popupId,
							displayInterval
						);
					}
					removeAllEventListener();
					document.removeEventListener(
						'click',
						clickCloseBtnCallbackFunc
					);
				};

				/**
				 * Handle outside click
				 *
				 * @param {Event} e
				 */
				const mouseDownCallbackFunc = ( e ) => {
					if (
						popupBodyBlock &&
						! popupBodyBlock.contains( e.target )
					) {
						block.style.display = 'none';
						if ( closeOnReVisitors ) {
							setDismissPopupDataOnLocalStorage(
								'db-close-popup',
								popupId,
								displayInterval
							);
						}
						removeAllEventListener();
					}
					document.removeEventListener(
						'mousedown',
						mouseDownCallbackFunc
					);
				};

				/**
				 * Handle esc key press
				 *
				 * @param {Event} e
				 */
				const keyupCallbackFunc = ( e ) => {
					if ( e.key === 'Escape' ) {
						block.style.display = 'none';
						if ( closeOnReVisitors ) {
							setDismissPopupDataOnLocalStorage(
								'db-close-popup',
								popupId,
								displayInterval
							);
						}
						removeAllEventListener();
						document.removeEventListener(
							'keyup',
							keyupCallbackFunc
						);
					}
				};

				if ( showCloseButton ) {
					closeBtn.addEventListener(
						'click',
						clickCloseBtnCallbackFunc
					);
				}
				if ( dismissBtn ) {
					setTimeout( () => {
						dismissBtn.addEventListener( 'click', () => {
							// Check if the dismiss button contains a link or is a link itself
							const link =
								dismissBtn.tagName === 'A'
									? dismissBtn
									: dismissBtn.querySelector( 'a' );

							if ( link && link.href ) {
								// If there's a hyperlink, let it execute first
								// Don't prevent default to allow link navigation

								// Delay the popup close to allow link navigation
								setTimeout( () => {
									clickCloseBtnCallbackFunc();
								}, 300 );
							} else {
								// No hyperlink, close immediately
								clickCloseBtnCallbackFunc();
							}
						} );
					}, 300 );
				}
				if ( closeOnClickOutside ) {
					document.addEventListener(
						'mousedown',
						mouseDownCallbackFunc
					);
				}
				if ( escOnClose ) {
					document.addEventListener( 'keyup', keyupCallbackFunc );
				}
			};
		}
	} );
} );
